import { FC, PropsWithChildren, useEffect, useMemo } from 'react'
import { SafeArea } from 'antd-mobile'
import TabBarCom from './components/TabBarCom'
import { handleLoginTrack } from '@/utils'
import { handleCheckRewardsNoReceived, loginStateAtom, store, useUserAtom } from '@/store'
import { checkTokenExpiration, getUserInfo } from '@/api'
import { isSuccess } from '@/axios'
import useSWR from 'swr'
import { useLocation } from 'react-router-dom'

const Layout: FC<PropsWithChildren> = (props) => {
  const { children } = props

  const { setUser } = useUserAtom()

  const location = useLocation()
  const isShow = useMemo(() => {
    return ['/', '/home/discover'].includes(location.pathname)
  }, [location.pathname])

  useSWR(
    '/user/detail/me',
    async () => {
      if (!store.get(loginStateAtom)) {
        return
      }

      if (location.pathname.includes('/writing')) {
        return
      }
      const resp = await getUserInfo()
      if (isSuccess(resp)) {
        setUser(resp.data)
        handleLoginTrack(resp.data)
        return resp
      }

      return undefined
    },
    { revalidateOnFocus: false },
  )

  useEffect(() => {
    handleCheckRewardsNoReceived()
    const interval = setInterval(checkTokenExpiration, 10 * 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <>
      <SafeArea position='top' />
      <>
        {children}
        {isShow ? (
          <div
            className='fixed bottom-0 left-0 z-30 h-[119px] w-full bg-[var(--global-footer-color,#1f2125)] pb-[15px] shadow-[0_-4px_19px_0_var(--global-top-shadow-color,rgba(0,0,0,0.4))] [&_.adm-tab-bar-item-icon]:h-auto [&_.adm-tab-bar-wrap]:h-full'
            id='bottomMenu'
          >
            <TabBarCom />
          </div>
        ) : null}
      </>
      <SafeArea position='bottom' />
    </>
  )
}

export default Layout
